import React,{
    useState
} from "react";

import axios from "axios";

import "./EditProfileModal.css";

import{

    X,

    User,

    Phone,

    Save

} from "lucide-react";

const EditProfileModal=({

    user,

    onClose,

    refreshProfile

})=>{

    const[

        name,

        setName

    ]=useState(

        user.name || ""

    );

    const[

        phone,

        setPhone

    ]=useState(

        user.phone || ""

    );

    const[

        loading,

        setLoading

    ]=useState(false);
        const saveProfile=async()=>{

        try{

            setLoading(true);

            await axios.put(

                "/api/ignite/profile",

                {

                    email:

                    user.email,

                    name,

                    phone

                }

            );

            refreshProfile();

            onClose();

        }

        catch(err){

            console.error(err);

            alert(

                "Unable to update profile."

            );

        }

        finally{

            setLoading(false);

        }

    };
        return(

        <div className="profile-modal-overlay">

            <div className="profile-modal">

                <div className="profile-modal-header">

                    <h2>

                        Edit Profile

                    </h2>

                    <button

                        onClick={onClose}

                    >

                        <X size={20}/>

                    </button>

                </div>

                <div className="profile-form">
                                        <label>

                        Full Name

                    </label>

                    <div className="profile-input">

                        <User size={18}/>

                        <input

                            type="text"

                            value={name}

                            onChange={(e)=>

                                setName(

                                    e.target.value

                                )

                            }

                        />

                    </div>
                                        <label>

                        Phone Number

                    </label>

                    <div className="profile-input">

                        <Phone size={18}/>

                        <input

                            type="text"

                            value={phone}

                            onChange={(e)=>

                                setPhone(

                                    e.target.value

                                )

                            }

                        />

                    </div>
                                    </div>

                <div className="profile-modal-footer">

                    <button

                        className="cancel-btn"

                        onClick={onClose}

                    >

                        Cancel

                    </button>

                    <button

                        className="save-btn"

                        disabled={loading}

                        onClick={saveProfile}

                    >

                        <Save size={18}/>

                        {

                            loading

                            ?

                            "Saving..."

                            :

                            "Save Changes"

                        }

                    </button>

                </div>

            </div>

        </div>

    );

};

export default EditProfileModal;